<!-- <p>virtual-sensors works!</p> -->
<div class="main-vs" *ngIf="!asset">
    <div *ngIf="organisation" class="title alignRow">
        <span>{{ organisation.Name }} Virtual DataPoints</span>
        <span class="toolbar-spacer"></span>
        <mat-icon (click)="createVirtualSensor()">add</mat-icon>
    </div>

    <div *ngIf="dataSource" class="table-container">
        <mat-form-field>
            <mat-label>Search</mat-label>
            <input matInput placeholder="" #input>
        </mat-form-field>
        <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="VirtualSensorName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Virtual DataPoint Name </th>
                <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row">
                    {{row.VirtualSensorName}} </td>
            </ng-container>
            <ng-container matColumnDef="InputDataPoints">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Input DataPoints</th>
                <td style="cursor: pointer;" mat-cell *matCellDef="let row">
                    <div *ngFor="let dp of row._dataPoints">{{dp.value}}: {{dp.datapoint.DPTitle}}</div>
                </td>
            </ng-container>
            <ng-container matColumnDef="Conversion">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Conversion</th>
                <td style="cursor: pointer;" mat-cell *matCellDef="let row">
                    <span>{{row.Conversion}}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="Edit">
                <th mat-header-cell *matHeaderCellDef></th>
                <td style="cursor: pointer;" mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="editVirtualSensor(row)">
                        <mat-icon>edit</mat-icon>
                    </button>
                </td>
            </ng-container>
            <ng-container matColumnDef="Delete">
                <th mat-header-cell *matHeaderCellDef></th>
                <td style="cursor: pointer;" mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="requestDeleteVirtualSensor(row)">
                        <mat-icon style="color: salmon;">delete</mat-icon>
                    </button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row class="table-row" *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td *ngIf="input.value != ''" class="mat-cell" colspan="4">No Data Matching the Filter:
                    "{{input.value}}"</td>
                <td *ngIf="input.value == ''" class="mat-cell" colspan="4">No Data Matching the Filter</td>
            </tr>
        </table>
        <mat-paginator #MatPaginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"
            aria-label="Select page of rules"></mat-paginator>
    </div>
</div>

<div class="tab-box" *ngIf="asset">
    <nav class="location-title">
        <span>Asset Virtual DataPoints: </span>
        <span class="toolbar-spacer"></span>
        <span class="app-icon app-icon--add" style="float: right;" matTooltip="Add Virtual DataPoint" (click)="addVirtualSensor()">
            <mat-icon />
        </span>
    </nav>
    <div class="virtual-sensor-item">
        <span>Name</span>
        <span>Input DataPoints</span>
        <span>Conversion</span>
    </div>
    <ejs-listview [dataSource]='assetVirtualSensors' cssClass="e-list-template">
        <ng-template #template let-dataSource>
            <div class="ejs-listview-item virtual-sensor-item">
                <span>{{dataSource.VirtualSensorName}}</span>
                <div class="input-dps">
                    <span *ngFor="let dp of dataSource._dataPoints">{{dp.value}}: {{dp.datapoint.DPTitle}}</span>
                </div>
                <span>{{dataSource.Conversion}}</span>
                <span class="app-icon app-icon--edit alignColumn" matTooltip="Edit {{dataSource.VirtualSensorName}}"
                    (click)="editVirtualSensor(dataSource)"><mat-icon /></span>
                <span class="app-icon app-icon--delete alignColumn" matTooltip="Remove {{dataSource.VirtualSensorName}}"
                    (click)="removeVirtualSensor(dataSource)"><mat-icon /></span>
            </div>
        </ng-template>
    </ejs-listview>
</div>